"use client";

import type { FieldValues, Path, UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";

type FilterTrueFalseProps<T extends FieldValues> = {
  paramName: Path<T>;
  form: UseFormReturn<T, any, T>;
  label: string;
};

export const FilterTrueFalseForm = <T extends FieldValues>({
  paramName,
  form,
  label,
}: FilterTrueFalseProps<T>) => {
  return (
    <FormField
      control={form.control}
      name={paramName}
      render={({ field }) => (
        <FormItem className="my-2 flex items-center justify-between space-x-4 space-y-0 rounded-lg bg-white p-4">
          <FormLabel className="font-base font-normal leading-5">
            {label}
          </FormLabel>

          <FormControl>
            <Switch
              className="m-0 h-[30px] w-[50px] data-[state=checked]:bg-brand-green-300 [&>span]:h-7 [&>span]:w-7"
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
